export const AI_IMPORT_PRESETS = [
  {
    key: "general",
    label: "General",
    description: "Balanced conversion for mixed workplace documents.",
  },
  {
    key: "checklist",
    label: "Checklist",
    description: "Short practical checks, ideal for routine inspections.",
  },
  {
    key: "audit",
    label: "Audit",
    description: "Scored compliance checks with evidence-focused drafting.",
  },
  {
    key: "sop",
    label: "SOP",
    description: "Instruction-led flow for standard operating procedures.",
  },
  {
    key: "workflow",
    label: "Workflow",
    description: "Staged handoff drafting for multi-user processes.",
  },
  {
    key: "cleaning",
    label: "Cleaning",
    description: "Routine area-based cleaning checks with repeatable sections.",
  },
  {
    key: "safety",
    label: "Safety",
    description: "Hazard and compliance checks with evidence-ready prompts.",
  },
  {
    key: "maintenance",
    label: "Maintenance",
    description: "Asset and fault-style checks for repairs and inspections.",
  },
  {
    key: "food_safety",
    label: "Food Safety",
    description: "Temperature, hygiene, and sign-off focused compliance checks.",
  },
];

export function getBuiltInPreset(key) {
  return AI_IMPORT_PRESETS.find((preset) => preset.key === key) || AI_IMPORT_PRESETS[0];
}

export function resolvePresetSelection(selection, customPresets = []) {
  const value = String(selection || "general");
  if (value.startsWith("custom:")) {
    const customId = value.slice("custom:".length);
    const customPreset = (Array.isArray(customPresets) ? customPresets : []).find((preset) => preset.id === customId);
    if (customPreset) {
      return {
        selection: value,
        label: customPreset.name,
        presetKey: customPreset.basePresetKey || "general",
        customPresetName: customPreset.name,
        customPresetInstructions: customPreset.extraInstructions || "",
        customPresetStarterSections: Array.isArray(customPreset.starterSections) ? customPreset.starterSections : [],
        customPresetStarterFieldTemplates: Array.isArray(customPreset.starterFieldTemplates) ? customPreset.starterFieldTemplates : [],
        customPresetId: customPreset.id,
      };
    }
  }

  const builtIn = getBuiltInPreset(value);
  return {
    selection: builtIn.key,
    label: builtIn.label,
    presetKey: builtIn.key,
    customPresetName: "",
    customPresetInstructions: "",
    customPresetStarterSections: [],
    customPresetStarterFieldTemplates: [],
    customPresetId: null,
  };
}

export function parseStarterFieldTemplates(input) {
  return String(input || "")
    .split("|")
    .map((entry) => entry.trim())
    .filter(Boolean)
    .map((entry) => {
      const [sectionTitlePart, fieldsPart] = entry.split(":");
      const sectionTitle = String(sectionTitlePart || "").trim();
      const fields = String(fieldsPart || "")
        .split(",")
        .map((field) => field.trim())
        .filter(Boolean)
        .slice(0, 20);
      if (!sectionTitle || fields.length === 0) return null;
      return { sectionTitle, fields };
    })
    .filter(Boolean)
    .slice(0, 12);
}

export function formatStarterFieldTemplates(templates = []) {
  return (Array.isArray(templates) ? templates : [])
    .map((template) => `${template.sectionTitle}: ${(Array.isArray(template.fields) ? template.fields : []).join(", ")}`)
    .join(" | ");
}
